import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

const Layout = () => {
  return (
    <div className="bg-gradient-to-br from-green-100 to-yellow-100 min-h-screen flex flex-col">
      <Header />
      <main className="container mx-auto px-4 py-8 flex-grow">
        <Outlet /> {/* Child routes will render here */}
      </main>
    </div>
  );
};

export default Layout;


